import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core'
import { AuthService, MatrixServices, RestServices } from '../../services'
import { getImageRedirectUrl } from '.../../helper'

@Component({
    selector: 'app-image-upload',
    templateUrl: './image-upload.component.html',
    styleUrls: ['./image-upload.component.css',
        '../../stagingcss/root-ui-view.component.css',
        '../../stagingcss/ui-schema-table-form.component.css',
        '../../stagingcss/main-body.component.css',
        '../../stagingcss/lui-select.component.css',
        '../../stagingcss/image-viewer.component.css'],
})
export class ImageUploadComponent implements OnInit, OnDestroy {

    ngOnInit(): void {
    }

    ngOnDestroy(): void {
    }

    maxSize = 256
    animationDuration: any = 3500
    arrIndexImg: any[] = []
    @ViewChild('imageWrapper') imageWrapper: ElementRef
    @Input() type = 'image'
    @Input() item = -1
    @Input() arrShowStatus: any[] = []
    @Input() arrAll: any[] = []
    @Input() arrRegistration: any[] = []
    @Input() page?: string

    @Input() opitionShowLoading = true
    @Output() _drop: EventEmitter<any> = new EventEmitter()
    @Output() _onUploadError: EventEmitter<any> = new EventEmitter()
    @Output() _dropStart: EventEmitter<any> = new EventEmitter()

    constructor(
        private authData: AuthService,
        private restApi: RestServices,
        public matrixServices: MatrixServices) {
    }

    allowDrop(event) {
        event.preventDefault()
    }

    drop(event, item) {
        event.preventDefault()
        this.processUploadFile(event.dataTransfer.files, item)
    }

    private getUrlImage(item, url) {
        if (url == '') {
            if (undefined !== this.arrRegistration && this.arrRegistration.length > 0) {
                const tmp: any = this.arrRegistration[item]
                if (tmp != undefined && tmp['id'] != '') {
                    return getImageRedirectUrl(tmp['id'])
                }
            }
            return ''
        } else {
            return url
        }
    }

    private getDataList(startIndex) {
        this.arrIndexImg = []
        const arrImg = this.arrShowStatus
        //always change file in startIndex
        this.arrIndexImg.push({ index: startIndex, isUploaded: false })
        if(this.page && this.page == "dental"){
            for (let i = 0; i < 18; i++) {
                //check index have status false
                if (!arrImg[i] && i !== startIndex) {
                    this.arrIndexImg.push({ index: i, isUploaded: false })
                }
            }
        }
        else{
            for (let i = 0; i < 6; i++) {
                //check index have status false
                if (!arrImg[i] && i !== startIndex) {
                    this.arrIndexImg.push({ index: i, isUploaded: false })
                }
            }
        }
        

    }

    // 256MB
    checkMaxSizeUpload(file) {
        if (file['size'] / 1024 / 1024 > this.maxSize) {
            return false
        }
        return true
    }

    private checkMimeType(file) {
        let excrptFile: any = 'image/'
        let tmpFile: any = file
        let typeFile: String = tmpFile['type']
        switch (this.type) {
            case 'image':
                excrptFile = 'image/'
                break
            case 'video':
                excrptFile = 'video'
                break
        }
        return typeFile.includes(excrptFile)
    }

    private getIndexUploadImage(item, fileList) {
        let i = 0
        if (fileList && fileList.length > 0) {
            for (let index = 0; index < fileList.length; index++) {
                const element = fileList[index]
                if (element === item) {
                    return i
                }
                if (this.checkMaxSizeUpload(element) && this.checkMimeType(element)) {
                    i++
                }
            }
        }
    }

    private processUploadFile(fileList, index) {
        if (this.arrAll.length > 0) {
            //load index need to upload
            this.getDataList(index)
            const fileCount = fileList.length
            for (let idx = 0; idx < fileCount; idx++) {
                //check file need to upload
                if (idx >= this.arrIndexImg.length) {
                    break
                }
                const file = fileList[idx]
                const reader = new FileReader()
                reader.readAsDataURL(file)
                if (fileList && fileList.length > 0 && this.checkMaxSizeUpload(file) && this.checkMimeType(file)) {
                    if (this.opitionShowLoading) {
                        this._dropStart.emit({
                            listUpload: this.arrIndexImg,
                            animationDuration: this.animationDuration,
                            arrLenghtImageFile: fileList.length,
                            item: index
                        })
                    }
                    this.authData.authToken().then(tokenReNew => {
                        this.restApi.postFile(file, tokenReNew).subscribe(
                            success => {
                                let event: any = {}
                                event.success = success
                                if (this.checkProcessUpload()) {
                                    const indexImage = this.getIndexUploadImage(file, fileList)
                                    const i = this.arrIndexImg[indexImage].index
                                    reader.onload = (event: any) => {
                                        this.arrShowStatus[i] = true
                                        this.getUrlImage(i, event.target.result)
                                    }
                                    event.item = i
                                    this._drop.emit(event)
                                    this.updateStatusImageUpload(indexImage)
                                }
                            },
                        )
                    })
                } else {
                    this._onUploadError.emit()
                }

            }
        }
    }

    private updateStatusImageUpload(indexImage) {
        for (let index = 0; index < this.arrIndexImg.length; index++) {
            let element = this.arrIndexImg[index]
            if (indexImage === index) {
                element.isUploaded = true
            }
        }
    }

    private checkProcessUpload() {
        for (let index = 0; index < this.arrIndexImg.length; index++) {
            const element = this.arrIndexImg[index]
            if (!element.isUploaded) {
                return true
            }

        }
        return false
    }
}



// WEBPACK FOOTER //
// ./src/app/commons/image-upload/image-upload.component.ts